import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getDataWithStudent } from "../../../lib/activitylist";
import { getNotesData, addData, updateData } from "../../../lib/pagenotes";
import { deleteIdData } from "../../../lib/activitylist";
//import {useAuth} from "../../../usercontext";

const styles = `
  .description-cell {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 3em;
    transition: max-height 0.3s ease;
    max-width: 35rem;
	margin-right: 1rem;
  }
  
  .description-cell:hover {
    -webkit-line-clamp: unset;
    max-height: none;
    position: relative;
    z-index: 1;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 0.5rem;
    border-radius: 0.25rem;
    max-width: 40rem;
	margin-right: 1rem;
  }

  .table th {
    white-space: nowrap;
    vertical-align: middle;
  }

  .table th .btn-link {
    padding: 0;
    margin-left: 0.5rem;
    vertical-align: middle;
    line-height: 1;
  }
`

const styleSheet = document.createElement('style')
styleSheet.innerText = styles
document.head.appendChild(styleSheet)

export default function GlobalStudentActivityList({ slug, isStudent, show = true, studentRole }) {
	const [activitylist, setActivityList] = useState([])
	const [description, setDescription] = useState()
	const [recId, setRecId] = useState()
	const [status, setStatus] = useState('')
	const [showMessage, setShowMessage] = useState(false)
	const [sortOrder, setSortOrder] = useState('asc')
	const [sortField, setSortField] = useState(null)

	const pageName = 'StudentActivityGoals'

	console.log('slug', slug)

	const handleSort = (field) => {
		const sortedList = [...activitylist].sort((a, b) => {
			if (field === 'description') {
				const aValue = a.description || ''
				const bValue = b.description || ''
				return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
			} else if (field === 'category') {
				const aValue = a.category || ''
				const bValue = b.category || ''
				return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
			} else if (field === 'position') {
				const aValue = a.position || ''
				const bValue = b.position || ''
				return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
			} else if (field === 'sortorder') {
				const aValue = a.sortorder || 0
				const bValue = b.sortorder || 0
				return sortOrder === 'asc' ? aValue - bValue : bValue - aValue
			} else if (field === 'gradelevel') {
				const aValue = a.gradelevel || ''
				const bValue = b.gradelevel || ''
				return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
			} else if (field === 'hoursperweek') {
				const aValue = a.hoursperweek || 0
				const bValue = b.hoursperweek || 0
				return sortOrder === 'asc' ? aValue - bValue : bValue - aValue
			} else if (field === 'weeksperyear') {
				const aValue = a.weeksperyear || 0
				const bValue = b.weeksperyear || 0
				return sortOrder === 'asc' ? aValue - bValue : bValue - aValue
			} else if (field === 'recoglevel') {
				const aValue = a.recoglevel || ''
				const bValue = b.recoglevel || ''
				return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
			}
			return 0
		})

		setActivityList(sortedList)
		setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
		setSortField(field)
	}

	const handleDelete = async (id) => {
		const choice = window.confirm('Are You Sure?')
		if (choice) {
			await deleteIdData(id)
			getDatafromActivityList()
			console.log('Delete', id)
		}
	}

	async function getDatafromActivityList() {
		const activity = await getDataWithStudent(slug)
		//console.log("activity", activity);
		setActivityList(activity)
	}

	async function RecordCheck() {
		const sdata = await getNotesData(slug, '', pageName)
		//console.log("RecordCheck", sdata);

		if (sdata.length === 0) {
			setStatus('Add')
		} else {
			setStatus('Update')
			setRecId(sdata[0].id)
			GetNotes()
		}
	}

	async function GetNotes() {
		const sdata = await getNotesData(slug, '', pageName)
		setDescription(sdata[0].instructorNote)
		setRecId(sdata[0].id)
	}

	const handleSubmitforGoals = async (e) => {
		e.preventDefault()
		if (status == 'Add') {
			console.log(' InstructorAdd')

			await addData({
				page: pageName,
				studentId: slug,
				instructorNote: description
			})
			setStatus('Update')
		} else {
			await updateData({
				id: recId,
				page: pageName,
				studentId: slug,
				instructorNote: description
			})
		}
		setShowMessage(true)
	}

	const messages = () => {
		return (
			<div className="alert alert-success alert-dismissible fade show" role="alert">
				<strong>Data Updated...</strong> {/*You should check in on some of those fields below.*/}
				<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={(e) => setShowMessage(false)}></button>
			</div>
		)
	}

	useEffect(() => {
		RecordCheck()
		getDatafromActivityList()
	}, [])

	const essentialheader = (
		name,
		student911buttonname,
		student911buttonlink,
		student12buttonname,
		student12buttonlink,
		instructorbuttonname,
		instructorbuttonlink
	) => {
		return (
			<div className="d-flex p-2 pb-0 justify-content-between align-items-center">
				<div>
					<h4 className="px-2">{name}</h4>
					<p></p>
				</div>
				<div className="d-flex">
					<div className="ticket-btn-grp">
						{show ? (
							isStudent ? (
								studentRole === 'Student911' ? (
									<Link to={student911buttonlink}>{student911buttonname}</Link>
								) : (
									<Link to={student12buttonlink}>{student12buttonname}</Link>
								)
							) : (
								<Link to={instructorbuttonlink}>{instructorbuttonname}</Link>
							)
						) : (
							''
						)}
					</div>
				</div>
			</div>
		)
	}

	return (
		<div className="col-12 p-0">
			<div className="settings-widget profile-details">
				<div className="settings-inner-blk p-1">
					{/* <div className="profile-heading">
          <h3 className="goal_settings_title">Student Activity</h3>
          <div className="new-address">
            <div className="row">
              <div className="col"></div>
              <div className="col"> </div>
              <div className="col">
                {show ? (
                  isStudent ? (
                    studentRole === "Student911" ? (
                      <Link
                        to="/student911/student-activity-edit/Add/0"
                        className="btn btn-dark btn-dark-1"
                      >
                        Add New Activity
                      </Link>
                    ) :
                      (
                        <Link
                          to="/student12/student-activity-edit/Add/0"
                          className="btn btn-dark btn-dark-1"
                        >
                          Add New Activity
                        </Link>
                      )
                  ) : (
                    <Link
                      to={`/instructor/instructor-studentactivity-edit/${slug}/Add/0`}
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Activity
                    </Link>
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div> */}
					{essentialheader(
						'Student Activity',
						'Add New Activity',
						`/student911/student-activity-edit/Add/0`,
						'Add New Activity',
						`/student12/student-activity-edit/Add/0`,
						'Add New Activity',
						`/instructor/instructor-studentactivity-edit/${slug}/Add/0`
					)}

					<div className="settings-invoice-blk table-responsive">
						<div className="px-2">
							<table className="table table-hover text-center">
								<thead>
									<tr>
										<th>
											<div className="d-flex align-items-center">
												Order
												<button className="btn btn-link" onClick={() => handleSort('sortorder')}>
													{sortField === 'sortorder' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Grade Level
												<button className="btn btn-link" onClick={() => handleSort('gradelevel')}>
													{sortField === 'gradelevel' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Hour/Week
												<button className="btn btn-link" onClick={() => handleSort('hoursperweek')}>
													{sortField === 'hoursperweek' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Week/Year
												<button className="btn btn-link" onClick={() => handleSort('weeksperyear')}>
													{sortField === 'weeksperyear' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Recog. Level
												<button className="btn btn-link" onClick={() => handleSort('recoglevel')}>
													{sortField === 'recoglevel' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Category
												<button className="btn btn-link" onClick={() => handleSort('category')}>
													{sortField === 'category' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Position
												<button className="btn btn-link" onClick={() => handleSort('position')}>
													{sortField === 'position' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										<th>
											<div className="d-flex align-items-center">
												Description
												<button className="btn btn-link" onClick={() => handleSort('description')}>
													{sortField === 'description' ? (sortOrder === 'asc' ? '▲' : '▼') : '⇅'}
												</button>
											</div>
										</th>
										{show && <th>Actions</th>}
									</tr>
								</thead>
								<tbody>
									{activitylist.map(function (data) {
										return (
											<tr key={`order-${data.id}`}>
												<td>{data.sortorder}</td>
												<td>{data.gradelevel}</td>
												<td>{data.hoursperweek}</td>
												<td>{data.weeksperyear}</td>
												<td>{data.recoglevel}</td>
												<td>{data.category}</td>
												<td>{data.position}</td>
												<td className="text-start">
													<div className="description-cell">{data.description}</div>
												</td>
												{show && (
													<td>
														<div className="d-flex align-items-center">
															{isStudent ? (
																studentRole === 'Student911' ? (
																	<Link to={`/student911/student-activity-edit/Update/${data.id}`} className="btn btn-success btn-sm ">
																		Update
																	</Link>
																) : (
																	<Link to={`/student12/student-activity-edit/Update/${data.id}`} className="btn btn-success btn-sm">
																		Update
																	</Link>
																)
															) : (
																<Link to={`/instructor/instructor-studentactivity-edit/${slug}/Update/${data.id}`} className="btn btn-success btn-sm">
																	Update
																</Link>
															)}
															<button className="btn btn-danger btn-sm mx-1" onClick={() => handleDelete(data.id)}>
																Delete
															</button>
														</div>
													</td>
												)}
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					</div>
					<div className="settings-invoice-blk table-responsive mt-5">
						{showMessage ? messages() : ''}
						<form role="form" onSubmit={handleSubmitforGoals}>
							<div className="row mx-auto">
								<div className="col-12">
									<div className="form-group">
										<label className="form-control-label">Goals and Recommendation</label>
										<textarea
											rows="4"
											value={description}
											onChange={(e) => setDescription(e.target.value)}
											className="form-control"
											placeholder="Description"
										></textarea>
									</div>
								</div>
								{show && (
									<>
										{!isStudent && (
											<div className="update-profile d-flex justify-content-between">
												<button type="submit" className="btn btn-primary">
													Goals and Recommendation Update
												</button>
											</div>
										)}
									</>
								)}
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}
